import React from 'react';
import styled from 'react-emotion';

import BaseDialogActions from './DialogActions';

const DialogActions = styled(BaseDialogActions)`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  margin: 0px;
  padding: 16px 24px 24px;
`;

export default React.memo(DialogActions);
